import { useEffect, useState } from 'react'
import { useSceneStore } from '@/stores/scene-store'

const HINT_TEXT = 'continue rolando'
const IDLE_DELAY_MS = 800
const VISIBLE_RANGE_START = 0.02
const VISIBLE_RANGE_END = 0.85

export function useScrollHintModel() {
  const rawProgress = useSceneStore((state) => state.rawProgress)
  const [isIdle, setIsIdle] = useState(false)

  useEffect(() => {
    let idleTimeoutId = setTimeout(() => setIsIdle(true), IDLE_DELAY_MS)

    function handleScroll(): void {
      setIsIdle(false)
      clearTimeout(idleTimeoutId)
      idleTimeoutId = setTimeout(() => setIsIdle(true), IDLE_DELAY_MS)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      clearTimeout(idleTimeoutId)
    }
  }, [])

  const isWithinJourney =
    rawProgress > VISIBLE_RANGE_START && rawProgress < VISIBLE_RANGE_END

  return {
    hintText: HINT_TEXT,
    isVisible: isIdle && isWithinJourney,
  }
}
